export default "__VITE_PUBLIC_ASSET__475fedc2__"